/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Expander } from '../platformLayout/tv/Dashboard/helperComponent/ExpandableTile';
import { useNavigate } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { BA_ACTION, ENTITYNAME, MEDIA_TRANSMISSION, MEDIACATEGORIES, TOAST_TYPES } from '../../framework/constant/constant';
import { Checkbox } from '@progress/kendo-react-inputs';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { useTranslation } from '../../locale/useTranslation';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import InfoRoundButton from '../../components/InfoRoundButton';
import { ContentEditForm } from '../masters/ContentEditForm';
import LanguageTranslator from '../../components/LanguageTranslator';
import { DataHelper } from '../../framework/helper/DataHelper';
import { GenreEditForm } from '../masters/GenreEditForm';
import MMImageEditForm from './MMImageEditForm';
import TMDBEditForm from './TMDBEditForm';
import ImageCard from './component/ImageCard';
import BossDialog from '../../components/BossDialog';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import BossAssistantIcon from './component/BossAssistantIcon';
import moment from 'moment';
import MyMultiSelect from '../../components/MyMultiSelect';
import ToastNotification from '../../components/ToastNotification';
import MediaHeroCard from './component/MediaHeroCard';

const SeriesDetailForm = ({ dataItem, setDataItem, isArchiveChanged, setIsArchiveChanged, createSeasonEpisode, setCreateSeasonEpisode, ...props }) => {

  const [i, setI] = useState(0);
  const [content, setContent] = useState([]);
  const [seasonContent, setSeasonContent] = useState([]);
  const [episodeContent, setEpisodeContent] = useState([]);
  const [openImageBank, setOpenImageBank] = useState(false);
  // const [mediaCategory, setMediaCategory] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState('https://i.postimg.cc/j5PsF5jZ/defaultmovie.png');
  const [seasonEpisodeDataItem, setSeasonEpisodeDataItem] = useState({
    SeasonContent: {},
    SeasonNumber: 0,
    EpisodeContent: {},
    NumberOfEpisodes: 0,
    Duration: '00:00:00:00',
    SeasonCode: "",
  });
  const [openImageInput, setOpenImageInput] = useState(false);

  const defaultFormState = {
    Content: false,
  }
  const [showEditForm, setShowEditForm] = useState(defaultFormState);

  //on create new entity and edit quickEdit is false but on quickEdit click quickEdit is true
  const [openForm, setFormOpen] = useState((dataItem.SID == 0 && !props?.isFromAddProgram) || props.quickEdit || props?.isManageContent);
  const [showSeriesOverview, setShowSeriesOverview] = useState(dataItem.SID == 0 ? true : false);
  const [showTranslateForm, setShowTranslateForm] = useState(false);
  const [showTMDBForm, setShowTMDBForm] = useState(false);
  const [genres, setGenres] = useState([]);
  const [currentUserChannels, setCurrentUserChannels] = useState([]);
  const [transmissions, setTransmissions] = useState([]);
  const [providers, setProviders] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [channels, setChannels] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [selectAllPlatforms, setSelectAllPlatforms] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [pgRatings, setPGRatings] = useState([]);

  const navigate = useNavigate();
  const lang = useTranslation();

  useEffect(() => {
    loadcombo();
    if (dataItem.SID > 0) {
      loadEditData();
    }
  }, []);

  useEffect(() => {
    setShowSeriesOverview(dataItem.SID == 0 ? true : false);
  }, [dataItem.SID]);

  const loadcombo = async () => {
    // let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
    // setMediaCategory(mediaCategory.data);
    let content = await API.getDataLookup(ENTITYNAME.Content, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    let filteredEpisodeContent = content.data.filter((item) => item.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Episode || item.MediaCategoryType.MediaCategorySID == 0);
    let filteredSeriesContent = content.data.filter((item) => item.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Series);
    let filteredSeasonContent = content.data.filter((item) => item.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Season)
    setEpisodeContent(filteredEpisodeContent);
    // setEpisodeContent(content.data);
    setSeasonContent(filteredSeasonContent);
    setContent(filteredSeriesContent);

    let genresRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
    setGenres(genresRes.data);

    let providerRes = await API.getDataLookup(ENTITYNAME.OttProvider, { sort: { Description: 1 } });
    setProviders(providerRes.data);

    let platformRes = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
    setPlatforms(platformRes.data);

    let channelRes = await API.getValidChannels(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
    setChannels(channelRes.data);


    let transmissionRes = Object.keys(MEDIA_TRANSMISSION).map((x) => ({
      _id: MEDIA_TRANSMISSION[x],
      Description: x
    }));
    setTransmissions(transmissionRes)

    let userChannels = await utility.getUserChannels()
    setCurrentUserChannels(userChannels)

    let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languageRes.data);

    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPGRatings(pgRatingRes.data);

    if ((dataItem.SID == 0 && !props?.isFromAddProgram)) {
      if (filteredSeasonContent.length > 0) {

        setDataItem({
          ...dataItem,
          Genres: utility.getDefaultItems(genresRes.data),
          SubGenres: utility.getDefaultItems(genresRes.data),
          AssetId: await DataHelper.getNewAssetId(filteredSeriesContent[0]),
          Content: filteredSeriesContent?.length > 0 ? filteredSeriesContent[0] : {},
          MediaType: dataItem.MediaType && dataItem.MediaType._id ? { _id: dataItem?.MediaType?._id, SID: dataItem?.MediaType?.SID, Description: dataItem?.MediaType?.Description } : {},
          MediaSubType: dataItem.MediaSubType && dataItem.MediaSubType._id ? { _id: dataItem?.MediaSubType?._id, SID: dataItem?.MediaSubType?.SID, Description: dataItem?.MediaSubType?.Description } : {},
        })
        setSeasonEpisodeDataItem({
          ...seasonEpisodeDataItem,
          SeasonContent: filteredSeasonContent?.length > 0 ? filteredSeasonContent[0] : {},
          EpisodeContent: filteredEpisodeContent?.length > 0 ? filteredEpisodeContent[0] : {}
        })
      }
    }

  }

  const onChange = async (e) => {
    let updatedItem = { ...dataItem };

    if (e.target.name === "Content") {
      updatedItem.Content = e.target.value;
      const updatedContent = await API.getAndSaveNextNumber(e.target.value.SID, { ...e.target.value, isSaveNextnumber: false });
      if (updatedContent.success) {
        updatedItem.AssetId = updatedContent.data.HouseNumber;
      }
    } else if (e.target.name === "Title") {
      updatedItem.Title = e.target.value;
      updatedItem.Description = e.target.value;
    } else if (e.target.name === "CustomTitle1" || e.target.name === "CustomTitle2") {
      let key = e.target.name === "CustomTitle1" ? "Title1" : "Title2";
      updatedItem.CustomTitle = {
        ...dataItem.CustomTitle,
        [key]: e.target.value
      };
    } else if (e.target.name === "isAllChannels") {
      const newValue = !selectAllChannels;
      setSelectAllChannels(newValue);
      updatedItem.Channels = newValue ? channels : [];
    } else if (e.target.name === "Channels") {
      updatedItem.Channels = e.target.value;
      setSelectAllChannels(e.target.value.length === channels.length);
    } else if (e.target.name === "isAllPlatforms") {
      const newValue = !selectAllPlatforms;
      setSelectAllPlatforms(newValue);
      updatedItem.Platforms = newValue ? platforms : [];
    } else if (e.target.name === "Platforms") {
      updatedItem.Platforms = e.target.value;
      setSelectAllPlatforms(e.target.value.length === platforms.length);
    } else if (e.target.name === "Archive") {
      setIsArchiveChanged(!isArchiveChanged);
      updatedItem.Archive = e.target.value;
    } else {
      updatedItem[e.target.name] = e.target.value;
    }

    setDataItem(updatedItem);
  };

  //create season episode part
  const handleCreateSeasonEpisodeChange = (e) => {
    setSeasonEpisodeDataItem({ ...seasonEpisodeDataItem, [e.target.name]: e.target.value });
  }

  const onAddClick = () => {

    if (Object.keys(seasonEpisodeDataItem.SeasonContent).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_season_content_series_error_message });
      return false;
    }
    if (seasonEpisodeDataItem.SeasonNumber == undefined || seasonEpisodeDataItem.SeasonNumber < 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.value_is_not_greater_then_zero_season_number_series_error_message });
      return false;
    }
    if (Object.keys(seasonEpisodeDataItem.EpisodeContent).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_epiosde_content_series_error_message });
      return false;
    }
    if (seasonEpisodeDataItem.NumberOfEpisodes == undefined || seasonEpisodeDataItem.NumberOfEpisodes < 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.value_is_not_greater_then_zero_episode_number_series_error_message });
      return false;
    }
    if (seasonEpisodeDataItem.Duration.includes("_") || seasonEpisodeDataItem.Duration == '00:00:00:00') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_duration_error_message });
      return false;
    }

    if (createSeasonEpisode.length != 0) {
      var checkDuplicate = createSeasonEpisode.filter((obj) => parseInt(obj.SeasonNumber) == parseInt(seasonEpisodeDataItem.SeasonNumber));
      if (checkDuplicate.length != 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entering_same_season_number_twice_series_error_message });
        return;
      }
    }
    setCreateSeasonEpisode((old) => [...old, { ...seasonEpisodeDataItem, Id: i + 1, Duration: utility.convertStringWithFramesToMilliseconds(seasonEpisodeDataItem.Duration), SeasonCode: seasonEpisodeDataItem.SeasonCode + (seasonEpisodeDataItem.SeasonNumber) }]);
    setSeasonEpisodeDataItem({
      SeasonNumber: 0,
      NumberOfEpisodes: 0,
      Duration: seasonEpisodeDataItem.Duration,
      EpisodeContent: seasonEpisodeDataItem.EpisodeContent,
      SeasonContent: seasonEpisodeDataItem.SeasonContent,
      SeasonCode: seasonEpisodeDataItem.SeasonCode
    });
    setI(i + 1);
  }

  const deleteSeasonDetails = (dataItem) => {
    setCreateSeasonEpisode(createSeasonEpisode.filter((obj) => dataItem.Id != obj.Id))
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  }

  const MyCommandCell = (props) => (<div>
    <DeleteRoundButton onClick={() => deleteSeasonDetails(props.dataItem)} />
  </div>)

  const loadEditData = async () => {
    setSelectedImageUrl(dataItem.ImageUrl);
  };

  const setSelectedImage = (dataList) => {
    setSelectedImageUrl(() => dataList[0].ImageUrl);
    setDataItem({ ...dataItem, ["ImageUrl"]: dataList[0].ImageUrl });
  }

  const onCancelEdit = () => {
    if (dataItem.SID == 0) {
      navigate(-1);
    } else if (props?.isManageContent) {
      props.onCancelEdit();
    } else {
      props.quickEdit ? navigate(-1) : setFormOpen(false);
    }
  }

  const isValid = () => {

    if (dataItem.Title == "" || dataItem.Title == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
      return false;
    }
    if (Object.keys(dataItem.Content).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_content_error_message });
      return false;
    }
    if (dataItem.Description == "" || dataItem.Description == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return false;
    }

    if (dataItem.SID == 0) {
      if (!dataItem?.Channels || dataItem.Channels.length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_channels_error_message });
        return false;
      }

      if (!dataItem?.isLinearUnlimitedRights) {
        if (!dataItem?.LinearStartDate || dataItem?.LinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.LinearEndDate || dataItem?.LinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_end_date_error_message });
          return false;
        }

        if (dataItem.LinearStartDate > dataItem.LinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.linear_start_and_end_date_error_message });
          return false;
        }
      }

      if (!dataItem?.isNonLinearUnlimitedRights) {
        if (!dataItem?.NonLinearStartDate || dataItem?.NonLinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.NonLinearEndDate || dataItem?.NonLinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_end_date_error_message });
          return false;
        }

        if (dataItem.NonLinearStartDate > dataItem.NonLinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.non_linear_start_and_end_date_error_message });
          return false;
        }
      }
    }


    return true
  }

  const onSaveData = async () => {
    if (!isValid()) return;

    if (props.quickEdit) {

      props.onSave();
      onCancelEdit();

    } else if (props?.isManageContent) {
      props.onSave();
      props.onCancelEdit();
    }
    else {
      setFormOpen(false);
    }

  };

  const onCreateMasterClick = (key) => {
    setShowEditForm({
      ...defaultFormState,
      [key]: true
    });
  }

  const handleLangugaeTranslate = (data) => {
    setDataItem({ ...dataItem, Synopsis: data });
    setShowTranslateForm(false);
  }

  const handleTMDBDataList = async (data) => {
    try {
      console.log("TMDB data received for mapping:", data);
      let tmdbGenres = data.Genres ? data.Genres.split(',').map(x => x.trim()).filter(Boolean) : [];
      let resolvedGenres = [];
      for (let i = 0; i < tmdbGenres.length; i++) {
        let item = tmdbGenres[i];
        let localGenre = genres.find(g => g?.Description?.toLowerCase() === item.toLowerCase());
        if (localGenre) {
          resolvedGenres.push(localGenre);
        } else {
          let newGenreRes = await API.saveData(ENTITYNAME.Genre, {
            Description: item,
            Archive: false,
            Code: item,
            ExternalDescription: item,
            AlternateDescription: item
          });
          if (newGenreRes.success) {
            resolvedGenres.push(newGenreRes.data);
            setGenres(prev => [...prev, newGenreRes.data]);
          }
        }
      }

      let prepareData = {
        Title: data.Title,
        Description: data.Overview,
        Synopsis: data.Overview,
        ProductionYear: data.Year,
        ImageUrl: data.Poster,
        Genres: resolvedGenres,
        SubGenres: resolvedGenres,
        SeasonNumber: data.SeasonsCount
      };

      setSelectedImageUrl(prepareData.ImageUrl);
      setDataItem({ ...dataItem, ...prepareData });

      // Populate seasons
      const defaultSeasonContent = seasonContent?.length > 0 ? seasonContent[0] : {};
      const defaultEpisodeContent = episodeContent?.length > 0 ? episodeContent[0] : {};

      let tmdbSeasonsList = (data.Seasons ?? [])
        .filter(s => s.season_number > 0)
        .map((s, index) => {
          return {
            Id: index + 1,
            SeasonContent: defaultSeasonContent,
            SeasonNumber: s.season_number,
            EpisodeContent: defaultEpisodeContent,
            NumberOfEpisodes: s.episode_count || 1,
            Duration: s.EpisodesList && s.EpisodesList.length > 0 && s.EpisodesList[0].runtime 
              ? s.EpisodesList[0].runtime * 60000 
              : 1800000, // Fallback to 30 mins
            SeasonCode: (dataItem.AssetId || "") + s.season_number,
            EpisodesList: s.EpisodesList || []
          };
        });

      setCreateSeasonEpisode(tmdbSeasonsList);
    } catch (err) {
      console.error("Error in handleTMDBDataList:", err);
      ToastNotification({ 
        type: TOAST_TYPES.ERROR, 
        title: "Metadata Mapping Error", 
        message: err.message || "Failed to process TMDB metadata" 
      });
    }
  };

  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.Thumbnail, item, dataItem);
    console.log(aiDataRes);
    return aiDataRes;

  }

  const setImageUrl = (data) => {
    if (data && data.success && data.imageUrl) {
      setSelectedImageUrl(data.imageUrl);
      setDataItem({ ...dataItem, ImageUrl: data.imageUrl });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: data.message });
    }
  }

  const style = {
    labelStyel: { fontSize: '11px', fontWeight: 600, color: '#3A3633', marginBottom: '3px', display: 'block' },
    sectionCard: { marginBottom: '16px', padding: '12px 14px', background: '#f5f5f5', borderRadius: '8px', border: '1px solid #e2e2e2' },
    posterCard: { padding: '10px 5px', background: '#f5f5f5', borderRadius: '8px', border: '1px solid #e2e2e2' },
    sectionHeader: { fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' },
  }
  const seriesLanguagesText = (dataItem?.Languages || []).map((obj) => obj?.Description).filter(Boolean).join(" | ");
  const seriesSummary = dataItem?.Description ? utility.subString(dataItem?.Description, 150) : "";
  const seriesHeroBadges = [
    dataItem?.PGRating?.Description,
    dataItem?.Content?.Description,
    dataItem?.ProductionYear ? `${dataItem?.ProductionYear}` : "",
    seriesLanguagesText,
  ].filter(Boolean);
  const seriesHeroFacts = [
    { label: lang.asset_id_label, value: `#${dataItem?.AssetId}` },
    { label: lang.content_label, value: dataItem?.Content?.Description },
    { label: lang.pg_rating_label ?? "PG Rating", value: dataItem?.PGRating?.Description },
    { label: lang.genre_label, value: (dataItem?.Genres || []).map((obj) => obj?.Description).filter(Boolean).join(" | ") },
    { label: lang.sub_genre_label, value: (dataItem?.SubGenres || []).map((obj) => obj?.Description).filter(Boolean).join(" | ") },
    { label: lang.languages_label ?? "Languages", value: seriesLanguagesText },
    { label: lang.production_year_label ?? "Production Year", value: dataItem?.ProductionYear },
    { label: lang.channel_label ?? "Channels", value: (dataItem?.Channels || []).map((obj) => obj?.FullChannelName).filter(Boolean).join(" | ") },
    { label: lang.platform_label ?? "Platforms", value: (dataItem?.Platforms || []).map((obj) => obj?.Description).filter(Boolean).join(" | ") },
    { label: lang.description_label, value: seriesSummary },
  ];

  return (
    <div className="mb-3 ml-2 mt-3" style={{ maxWidth: "70vw" }}>
      <MediaHeroCard
        imageUrl={dataItem?.ImageUrl}
        title={dataItem?.Title ? utility.subString(dataItem?.Title, 36) : lang.enter_title_expender}
        assetId={dataItem?.AssetId}
        badges={seriesHeroBadges}
        summary={seriesSummary}
        facts={seriesHeroFacts}
        expanded={showSeriesOverview}
        onToggleExpanded={() => setShowSeriesOverview((prev) => !prev)}
        actions={[
          {
            title: lang.edit_button_tooltip ?? "Edit",
            icon: "fa-solid fa-pen-to-square",
            onClick: () => setFormOpen(true),
          },
        ]}
      />
      {openForm && <BossDialog
        title={dataItem?.SID > 0 ? dataItem?.Title : `${lang.create_series_dialog_header}`}
        onClose={onCancelEdit}
        width={"960px"}
        height={dataItem?.SID > 0 ? "" : "685px"}
      >
        <div className="row mt-2 mb-2">
          <div className="marlr ml-3" style={{ display: 'flex', gap: '8px' }}>
            <SaveButton title={lang.confirm_button} tooltip={lang.confirm_button_tooltip} onClick={() => onSaveData()}></SaveButton>
            <CancelButton onClick={onCancelEdit}></CancelButton>
          </div>
        </div>

        <Form
          render={(formRenderProps) => (
            <FormElement>
              <div style={{ padding: '10px' }}>
                {/* --- Row 1: Title & Description + Poster Image Card --- */}
                <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
                  {/* Left: Title & Description */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ ...style.sectionCard, marginBottom: 0, height: '100%' }}>
                      <div style={style.sectionHeader}>{lang.title_and_description_section_header}</div>
                      <div className="row" style={{ marginBottom: '8px' }}>
                        <div className="col-6">
                          <label style={style.labelStyel}>
                            {lang.title_label} *
                            {(!dataItem.SID || dataItem.SID == 0 || dataItem.SID == "0") && (
                              <span className='cursor-pointer' style={{ backgroundColor: '#01b4e4', color: 'white', padding: '1px 6px', borderRadius: '3px', fontSize: '9px', marginLeft: '8px', verticalAlign: 'middle' }} onClick={() => setShowTMDBForm(true)}>
                                TMDB
                              </span>
                            )}
                          </label>
                          <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.Title} onChange={onChange} required style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                        <div className="col-3">
                          <label style={style.labelStyel}>{lang.custom_title_1_label}</label>
                          <input name="CustomTitle1" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title1 || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                        <div className="col-3">
                          <label style={style.labelStyel}>{lang.custom_title_2_label}</label>
                          <input name="CustomTitle2" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title2 || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: '8px' }}>
                        <div className="col-2">
                          <label style={style.labelStyel}>{lang.season_number_label}</label>
                          <input name="SeasonNumber" type="number" className="form-control form-control-sm" value={dataItem.SeasonNumber || 1} onChange={onChange} min={1} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                        <div className="col-4">
                          <label style={style.labelStyel}>{lang.transmission_label}</label>
                          <DropDownList
                            style={{ backgroundColor: "white", width: '100%' }}
                            data={transmissions}
                            textField='Description'
                            dataItemKey='_id'
                            name="Transmission"
                            value={dataItem.Transmission}
                            onChange={onChange}
                          />
                        </div>
                        <div className="col-3">
                          <label style={style.labelStyel}>{lang.short_title_label}</label>
                          <input name="ShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.ShortTitle || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                        <div className="col-3">
                          <label style={style.labelStyel}>{lang.custom_short_title_label}</label>
                          <input name="CustomShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.CustomShortTitle || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.description_label} *</label>
                          <textarea rows={2} name="Description" className="form-control form-control-sm" value={dataItem.Description || ''} onChange={onChange} required style={{ borderRadius: '4px', border: '1px solid #d0d0d0', resize: 'vertical' }} />
                        </div>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.custom_description_label || 'Custom Description'}</label>
                          <textarea rows={2} name="CustomDescription" className="form-control form-control-sm" value={dataItem.CustomDescription || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0', resize: 'vertical' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Right: Poster Image (same height as Title & Description portion) */}
                  <div style={{ width: '200px', flexShrink: 0, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ ...style.posterCard, width: '100%', height: '100%', marginBottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-pencil" title="Edit Image Url" style={{ cursor: 'pointer', fontSize: '14px', color: '#555' }} onClick={() => setOpenImageInput(true)}></i>
                        <i className="fa fa-file-text" title='Select Image' style={{ cursor: 'pointer', fontSize: '14px', color: '#555' }} onClick={() => setOpenImageBank(true)}></i>
                        <BossAssistantIcon
                          style={{ cursor: 'pointer' }}
                          mediaEpisodeEntity={dataItem}
                          iconSize={"18px"}
                          onDataLoad={onBossAIMetaDataLoad}
                          popupTtle={"Generate Thumbnail with Boss AI"}
                          tooltip={"Generate Thumbnail with Boss AI"}
                          description={"BOSS AI Generating Thumbnail"}
                          setMetaData={setImageUrl}
                        />
                      </div>
                      <div style={{ width: '100%', maxWidth: '180px', height: '200px', overflow: 'hidden', borderRadius: '8px', border: '1px solid #e2e2e2', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                        <ImageCard style={{ padding : 0, width: '100%', height: '100%', objectFit: 'cover' }} width={"100%"} height={"100%"} img={dataItem.ImageUrl} alt='Poster' />
                      </div>
                    </div>
                  </div>
                </div>

                {/* --- Row 2: Content & Identification --- */}
                <div style={style.sectionCard}>
                  <div style={style.sectionHeader}>{lang.content_and_identification_section_header}</div>
                  <div className="row">
                    <div className="col-3">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '3px' }}>
                        <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.content_label} *</label>
                        <TooltipInfoCard message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip} />
                      </div>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <DropDownList
                          style={{ width: '100%' }}
                          data={content}
                          name="Content"
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.Content}
                          onChange={onChange}
                          disabled={dataItem.SID > 0}
                        />
                        <button type="button" title={lang.create_content_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                          style={{ height: "30px", minWidth: '30px', padding: '0 5px', flexShrink: 0 }} onClick={() => onCreateMasterClick('Content')}><i className="fa-solid fa-plus fa-xs"></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.provider_label}</label>
                      <DropDownList
                        style={{ width: '100%' }}
                        data={providers}
                        name="Provider"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Provider}
                        onChange={onChange}
                      />
                    </div>

                    <div className="col-3">
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '3px' }}>
                        <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.asset_id_label}</label>
                        {dataItem.SID == 0 && <div style={{ display: "flex", alignItems: "center", gap: '2px' }}>
                          <Field
                            name="isManualAssetId"
                            component={Checkbox}
                            onChange={async (e) => {
                              if (!e.target.value) {
                                setDataItem({
                                  ...dataItem,
                                  AssetId: await DataHelper.getNewAssetId(dataItem.Content),
                                });
                              }
                              props.setIsManualAssetId(e.target.value);
                            }}
                            checked={props.isManualAssetId}
                            style={{ marginRight: "2px", borderColor: "black" }}
                          />
                          <label htmlFor="isManualAssetId" style={{ cursor: "pointer", fontSize: "10px", marginBottom: 0 }}>{lang.manual_label}</label>
                        </div>}
                      </div>
                      {props.isManualAssetId ? (
                        <input type="text" className="form-control form-control-sm" name="AssetId" value={dataItem.AssetId} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                      ) : (
                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e293b', marginTop: '2px' }}>{dataItem.AssetId}</div>
                      )}
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.series_code_label}</label>
                      <input name="SeasonCode" type="text" className="form-control form-control-sm" value={dataItem.SeasonCode || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                    </div>
                  </div>
                </div>

                {/* --- Row 3: Timing & Classification --- */}
                <div style={style.sectionCard}>
                  <div style={style.sectionHeader}>{lang.timing_and_classification_section_header}</div>
                  <div className="row" style={{ marginBottom: '8px' }}>
                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.genre_label} *</label>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <MultiSelect
                          style={{ width: '100%' }}
                          data={genres}
                          name={"Genres"}
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.Genres}
                          onChange={onChange}
                        />
                        <button type="button" title={lang.create_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                          style={{ height: "30px", minWidth: '30px', padding: '0 5px', flexShrink: 0 }} onClick={() => onCreateMasterClick('Genre')}><i className="fa-solid fa-plus fa-xs"></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.sub_genre_label}</label>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <MultiSelect
                          style={{ width: '100%' }}
                          data={genres}
                          name={"SubGenres"}
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.SubGenres}
                          onChange={onChange}
                        />
                        <button type="button" title={lang.create_sub_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                          style={{ height: "30px", minWidth: '30px', padding: '0 5px', flexShrink: 0 }} onClick={() => onCreateMasterClick('Genre')}><i className="fa-solid fa-plus fa-xs"></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.language_label || 'Language'}</label>
                      <MultiSelect
                        style={{ width: '100%' }}
                        data={languages}
                        name={"Languages"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Languages}
                        onChange={onChange}
                      />
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.dubbed_languages_label}</label>
                      <MultiSelect
                        style={{ width: '100%' }}
                        data={languages}
                        name={"DubbedLanguages"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.DubbedLanguages}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <div className="row" style={{ marginBottom: '8px' }}>
                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.production_year_label || 'Production Year'}</label>
                      <input name="ProductionYear" type="text" className="form-control form-control-sm" value={dataItem.ProductionYear || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.pg_rating_label || 'PG Rating'}</label>
                      <DropDownList
                        style={{ width: '100%' }}
                        data={pgRatings}
                        name="PGRating"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.PGRating}
                        onChange={onChange}
                      />
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.media_type_label}</label>
                      <DropDownList
                        style={{ width: '100%' }}
                        data={genres}
                        name={"MediaType"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.MediaType}
                        onChange={onChange}
                      />
                    </div>

                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.media_sub_type_label}</label>
                      <DropDownList
                        style={{ width: '100%' }}
                        data={genres}
                        name={"MediaSubType"}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.MediaSubType}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <div className="row" style={{ marginBottom: '8px' }}>
                    <div className="col-3">
                      <label style={style.labelStyel}>{lang.deal_reference_label}</label>
                      <input name="DealReference" type="text" className="form-control form-control-sm" value={dataItem.DealReference || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                    </div>

                    <div className="col-5">
                      <label style={style.labelStyel}>{lang.working_title_label}</label>
                      <input name="WorkingTitle" type="text" className="form-control form-control-sm" value={dataItem.WorkingTitle || ''} onChange={onChange} disabled style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                    </div>

                    <div className="col-4">
                      <label style={style.labelStyel}>{lang.parent_series_lable || 'Parent Series'}</label>
                      <div style={{ display: 'flex', gap: '3px' }}>
                        <input name="ParentSeries" type="text" className="form-control form-control-sm" value={dataItem.ParentSeries || ''} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                        <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" style={{ height: "30px", minWidth: "30px" }}><i className="fa-solid fa-ellipsis-vertical"></i></button>
                        <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" style={{ height: "30px", minWidth: "30px" }}><i className="fa-solid fa-xmark"></i></button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                        <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.synopsis_label}</label>
                        <label className='float-right cursor-pointer' onClick={() => setShowTranslateForm(true)} style={{ margin: 0 }}><i className="fa-solid fa-language" aria-hidden="true" style={{ fontSize: '16px', color: '#666' }}></i></label>
                      </div>
                      <textarea name="Synopsis" className="form-control form-control-sm" id="Description" value={dataItem.Synopsis || ''} onChange={onChange} required style={{ borderRadius: '4px', border: '1px solid #d0d0d0', resize: 'vertical', minHeight: '60px' }} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap', marginTop: '10px' }}>
                    {dataItem.SID > 0 && <div className="form-check" style={{ marginBottom: 0 }}>
                      <Field
                        style={{ borderColor: "black" }}
                        name={"Archive"}
                        component={Checkbox}
                        label={lang.archive}
                        onChange={onChange}
                        checked={dataItem.Archive ? true : false}
                      />
                    </div>}

                    <div className="form-check" style={{ marginBottom: 0 }}>
                      <Field
                        style={{ borderColor: "black" }}
                        name={"IsLive"}
                        component={Checkbox}
                        label={lang.islive_label}
                        onChange={onChange}
                        checked={dataItem.IsLive ? true : false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </FormElement>
          )}
        />


        {dataItem.SID == 0 && (<div className='row'>
          <div className='col-6'>
            <div style={style.sectionCard}>
              <div style={style.sectionHeader}>{lang.linear_deal_rights_label}</div>
              <div className='row'>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.linear_channels_label}<span className="text-danger">*</span></label>
                    <div className="d-flex align-items-end">
                      <div>
                        <input
                          type="checkbox"
                          name="isLinearUnlimitedRights"
                          className="ml-1"
                          checked={dataItem?.isLinearUnlimitedRights}
                          onChange={() =>
                            setDataItem({
                              ...dataItem,
                              isLinearUnlimitedRights: !dataItem?.isLinearUnlimitedRights
                            })
                          }
                        />
                        <span className="ml-1">{lang.is_unlimited_label}</span>
                      </div>
                      <div className='ml-1'>
                        <input
                          type="checkbox"
                          name="isAllChannels"
                          className="ml-1"
                          value={selectAllChannels}
                          checked={selectAllChannels}
                          onChange={onChange}
                        />
                        <span className="ml-1">{lang.select_all_label}</span>
                      </div>
                    </div>
                  </div>
                  <MyMultiSelect
                    data={channels}
                    name="Channels"
                    textField="FullChannelName"
                    dataItemKey="_id"
                    value={dataItem.Channels}
                    onChange={onChange}
                  />
                </div>
                {!dataItem?.isLinearUnlimitedRights ? <>
                  <div className="col-6">
                    <label style={style.labelStyel}>{lang.start_date_label} *</label>
                    <input
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="LinearStartDate"
                      value={dataItem.LinearStartDate}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                    <input
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="LinearEndDate"
                      value={dataItem.LinearEndDate}
                      onChange={onChange}
                    />
                  </div>
                </> :
                  <div className="col-12 mt-1">
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      Note: Linear Deal Rights validity will default from{" "}
                      <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                      {" "}to{" "}
                      <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                      {" "}when Unlimited is enabled.
                    </small>
                  </div>}
              </div>
            </div>
          </div>

          <div className='col-6'>
            <div style={style.sectionCard}>
              <div style={style.sectionHeader}>{lang.non_linear_deal_rights_label}</div>
              <div className='row'>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.non_linear_platforms_label}</label>
                    <div className="d-flex align-items-end">
                      <div>
                        <input
                          type="checkbox"
                          name="isNonLinearUnlimitedRights"
                          className="ml-1"
                          checked={dataItem?.isNonLinearUnlimitedRights}
                          onChange={() =>
                            setDataItem({
                              ...dataItem,
                              isNonLinearUnlimitedRights: !dataItem?.isNonLinearUnlimitedRights
                            })
                          }
                        />
                        <span className="ml-1">{lang.is_unlimited_label}</span>
                      </div>
                      <div className='ml-1'>
                        <input
                          type="checkbox"
                          name="isAllPlatforms"
                          className="ml-1"
                          value={selectAllPlatforms}
                          checked={selectAllPlatforms}
                          onChange={onChange}
                        />
                        <span className="ml-1">{lang.select_all_label}</span>
                      </div>
                    </div>
                  </div>
                  <MyMultiSelect
                    data={platforms}
                    name="Platforms"
                    textField="Description"
                    dataItemKey="_id"
                    value={dataItem.Platforms}
                    onChange={onChange}
                  />
                </div>
                {!dataItem?.isNonLinearUnlimitedRights ? <>
                  <div className="col-6">
                    <label style={style.labelStyel}>{lang.start_date_label} *</label>
                    <input
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="NonLinearStartDate"
                      value={dataItem.NonLinearStartDate}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                    <input
                      type="datetime-local"
                      className="form-control form-control-sm"
                      name="NonLinearEndDate"
                      value={dataItem.NonLinearEndDate}
                      onChange={onChange}
                    />
                  </div>
                </> :
                  <div className="col-12 mt-1">
                    <small className="text-muted" style={{ fontSize: "11px" }}>
                      Note: Non Linear Deal Rights validity will default from{" "}
                      <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                      {" "}to{" "}
                      <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                      {" "}when Unlimited is enabled.
                    </small>
                  </div>}
              </div>
            </div>
          </div>
        </div>)}

        {dataItem.SID == 0 && <>
          <div className='mt-2' style={{ padding: '6px', borderRadius: '8px', backgroundColor: '#F0EBE3' }}>
            <Expander expand={false} title={lang.seasons_title} img={dataItem.ImageUrl} color={"#F0EBE3"}>
              <div style={{ border: "1px solid #cbd5e1", borderRadius: '8px', padding: "20px", margin: "10px 8px 10px 8px", backgroundColor: '#ffffff' }}>
                <div className='row' style={{ marginBottom: '12px' }}>
                  <div className="col-2">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.s_content_label} *</label>
                      <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                    </div>
                    <DropDownList
                      style={{ backgroundColor: 'white', width: '100%' }}
                      data={seasonContent}
                      name="SeasonContent"
                      textField="Description"
                      dataItemKey="_id"
                      value={seasonEpisodeDataItem.SeasonContent}
                      onChange={handleCreateSeasonEpisodeChange}
                    />
                  </div>

                  <div className='col-2'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.season_no_label} *</label>
                    </div>
                    <input name="SeasonNumber" type="number" className="form-control form-control-sm" value={seasonEpisodeDataItem.SeasonNumber} onChange={(e) => handleCreateSeasonEpisodeChange(e)} min={1} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                  </div>

                  <div className="col-2">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.ep_content_label} *</label>
                      <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                    </div>
                    <DropDownList
                      style={{ backgroundColor: 'white', width: '100%' }}
                      data={episodeContent}
                      name="EpisodeContent"
                      textField="Description"
                      dataItemKey="_id"
                      value={seasonEpisodeDataItem.EpisodeContent}
                      onChange={handleCreateSeasonEpisodeChange}
                    />
                  </div>

                  <div className='col-2'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.episodes_label}</label>
                    </div>
                    <input name="NumberOfEpisodes" type="number" className="form-control form-control-sm" value={seasonEpisodeDataItem.NumberOfEpisodes} onChange={(e) => handleCreateSeasonEpisodeChange(e)} min={1} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                  </div>

                  <div className="col-2">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.duration_only_label} *</label>
                      <InfoRoundButton message={lang.time_hh_mm_ss_ff_label}></InfoRoundButton>
                    </div>
                    <TimePickerWithFormat
                      className="form-control form-control-sm"
                      name="Duration"
                      style={{ width: '100%', borderRadius: '4px', border: '1px solid #d0d0d0' }}
                      value={seasonEpisodeDataItem.Duration}
                      onChange={(e) => handleCreateSeasonEpisodeChange(e)}
                    />
                  </div>
                  <div className="col-2">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                      <label style={{ ...style.labelStyel, marginBottom: 0 }}>{lang.series_code_label}</label>
                    </div>
                    <input name="SeasonCode" type="text" className="form-control form-control-sm" value={seasonEpisodeDataItem.SeasonCode} onChange={(e) => handleCreateSeasonEpisodeChange(e)} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                  </div>
                </div>

                <div className='row' style={{ marginBottom: '12px' }}>
                  <div className='col-12'>
                    <AddRoundButton onClick={onAddClick}></AddRoundButton>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12'>
                    <Grid data={createSeasonEpisode} style={{ height: "20vh" }}>
                      <GridColumn cell={MyCommandCell} width={"42px"} locked={true} />
                      <GridColumn field="SeasonNumber" title={lang.season_number_column} editable={false} width={"140px"} />
                      <GridColumn field="NumberOfEpisodes" title={lang.no_of_episodes_column} editable={false} width={"140px"} />
                      <GridColumn field="SeasonContent.Description" title={lang.season_content_column} editable={false} width={"140px"} />
                      <GridColumn field="EpisodeContent.Description" title={lang.episode_content_column} editable={false} width={"170px"} />
                      <GridColumn field="Duration" title={lang.duration_column} editable={false} cell={TimeCell} width={"140px"} />
                      <GridColumn field="SeasonCode" editable={false} width={"140px"} />
                    </Grid>
                  </div>
                </div>
              </div>
            </Expander>
          </div>
          <p className='text-muted' style={{ fontSize: '11px', position: "relative", top: "20px", left: "15px" }}>{`* ${currentUserChannels && currentUserChannels.length == 1 ? `Deal Rights will automatically be created for ${currentUserChannels[0].FullChannelName}` : "Please create deal rights before saving"}`}</p>
        </>}
      </BossDialog>}
      {openImageBank && <CollectionSelection entityname={ENTITYNAME.OttPosters} closeForm={() => setOpenImageBank(!openImageBank)} setDataList={setSelectedImage} title={lang.select_image_collection_header} mode={"single"} width={"50vw"} />}

      {showEditForm.Content && <ContentEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadcombo()} filterMediaCategory={props.mediaCategory} />}
      {showTranslateForm && <LanguageTranslator onSubmit={handleLangugaeTranslate} cancelEdit={() => setShowTranslateForm(false)} />}
      {showEditForm.Genre && <GenreEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadcombo()} />}
      {/* Image Content Popup */}
      {openImageInput && <MMImageEditForm onClose={() => setOpenImageInput(false)} selectedImageUrl={dataItem.ImageUrl} setDataList={(img) => { setSelectedImageUrl(img); setDataItem({ ...dataItem, ["ImageUrl"]: img }) }} />}
      {showTMDBForm && <TMDBEditForm cancelEdit={() => setShowTMDBForm(false)} tmdbDataList={handleTMDBDataList} />}
    </div>

  )
}

export default SeriesDetailForm
